import { AppServices } from '@singularsystems/neo-core';
import { IParticipantsMessageApiClient } from './ApiClients/ParticipantsMessageApiClient';

import { ClientsSharedTypes as ClientsCommonTypes } from 'st-common/Clients/ClientsSharedTypes';

// Symbols to expose outside of this module
export const ClientsSharedTypes = {
    ApiClients: {
        ...ClientsCommonTypes.ApiClients,
        ParticipantsMessageApiClient: new AppServices.ServiceIdentifier<IParticipantsMessageApiClient>("Clients.ParticipantsMessageApiClient"),
    },
    Services: {
        ...ClientsCommonTypes.Services,
    }
}